import { Component, computed, input, output, OutputEmitterRef } from '@angular/core';

import { MDIconComponent, MDTagComponent } from '@melodic-ui/components';
import { LessonCardComponent } from '../lesson-card/lesson-card.component';
import { getLessonTypeIcon } from '../utils/lesson-type-colors.util';
import { ILessonListItem } from '@lb/api/mylb/interfaces';
import { IndicatorType } from '@melodic-ui/types';

@Component({
	selector: 'lb-readonly-lesson-card',
	standalone: true,
	imports: [MDIconComponent, MDTagComponent, LessonCardComponent],
	templateUrl: './readonly-lesson-card.component.html',
	styleUrl: './readonly-lesson-card.component.scss'
})
export class ReadonlyLessonCardComponent {
	public lesson = input.required<ILessonListItem>();
	public isPopup = input<boolean>(false);
	public displayedUser = input<'learner' | 'instructor'>('instructor');
	public detailsLink = input<(string | number)[] | null>(null);

	public dataChanged: OutputEmitterRef<void> = output();

	public lessonTypeIcon = computed(() => getLessonTypeIcon(this.lesson().lessonTypeID));

	// Attendance status 2 is "Absent"; everything else reads as present, matching the v2 card.
	private _isAbsent = computed(() => this.lesson().attendanceStatusID === 2);

	public attendanceIcon = computed(() => (this._isAbsent() ? 'untitled-ui/general/slash-circle-01' : 'untitled-ui/general/check-circle'));
	public attendanceTagType = computed<IndicatorType>(() => (this._isAbsent() ? 'warning' : 'success'));

	// Determine the lesson view based on displayedUser or default behavior
	public lessonView = () => {
		const displayedUser = this.displayedUser();
		if (displayedUser) {
			// If displayedUser is set, use the opposite for business logic context
			return displayedUser === 'learner' ? 'instructor' : 'learner';
		}
		// Default: this is typically used in learner context, so show instructor
		return 'learner';
	};
}
